// 「傳給親友看」：本家胡到大牌時跳出，用 LINE 分享炫耀（不附購買連結）
// 對應 docs/PRD-Freemium.md 第 6.1 節：平常就有互動，要錢的時候才不會突兀
//
// === 使用圖片 ===
// 無 — 純程式繪製（DOM overlay，不經 Phaser）

import { lineShareUrl } from '@net/shop-catalog';

const PROMPT_ID = 'mahjong-brag-prompt';
const PROMPT_Z_INDEX = '1950';
const CARD_BG = '#fff8ec';
const RED = '#a0322a';
const TITLE_FONT_PX = 34;
const BODY_FONT_PX = 22;
const BUTTON_FONT_PX = 26;
const AUTO_CLOSE_MS = 12_000; // 沒按就自動收起，不擋住結算

export const showBragPrompt = (handNames: readonly string[], tai: number): void => {
  if (typeof document === 'undefined' || document.getElementById(PROMPT_ID)) return;
  const message = `我剛在至尊麻將王胡了${handNames.join('、')}，${tai} 台！`;
  const overlay = document.createElement('div');
  overlay.id = PROMPT_ID;
  Object.assign(overlay.style, {
    position: 'fixed',
    left: '50%',
    bottom: '24px',
    transform: 'translateX(-50%)',
    zIndex: PROMPT_Z_INDEX,
    background: CARD_BG,
    border: `3px solid #e7c26b`,
    borderRadius: '20px',
    padding: '16px 24px',
    textAlign: 'center',
    color: '#3a2a1a',
    fontFamily: '"PingFang TC", "Microsoft JhengHei", system-ui, sans-serif',
    boxShadow: '0 8px 30px rgba(0,0,0,.35)',
    maxWidth: '90vw',
  });
  const title = document.createElement('div');
  title.textContent = '胡大牌了！';
  Object.assign(title.style, { fontSize: `${TITLE_FONT_PX}px`, fontWeight: 'bold' });
  const body = document.createElement('div');
  body.textContent = `${handNames.join('、')}，${tai} 台`;
  Object.assign(body.style, { fontSize: `${BODY_FONT_PX}px`, margin: '6px 0 12px' });
  const close = (): void => overlay.remove();
  const share = document.createElement('button');
  share.textContent = '傳給親友看';
  Object.assign(share.style, {
    fontSize: `${BUTTON_FONT_PX}px`,
    padding: '12px 28px',
    borderRadius: '14px',
    border: 'none',
    background: RED,
    color: '#fff',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginRight: '10px',
  });
  share.addEventListener('click', () => {
    window.open(lineShareUrl(`${message}\n${location.origin}/`), '_blank');
    close();
  });
  const later = document.createElement('button');
  later.textContent = '不用了';
  Object.assign(later.style, {
    fontSize: `${BUTTON_FONT_PX - 4}px`,
    padding: '12px 18px',
    borderRadius: '14px',
    border: `2px solid ${RED}`,
    background: 'transparent',
    color: RED,
    cursor: 'pointer',
  });
  later.addEventListener('click', close);
  overlay.append(title, body, share, later);
  document.body.append(overlay);
  setTimeout(close, AUTO_CLOSE_MS);
};
